import { isWebBridgeSupported } from '@shopee-user/platform';
import { AuthSource } from '@shopee-user/business-customization-types';
import type { AuthenticateChannel } from '@tob/shared/thirdparty-auth/core/types';

export function getLoginRedirectionParameters(options?: {
  thirdPartyChannel?: AuthenticateChannel;
}): Record<string, string | undefined> {
  const base = isWebBridgeSupported()
    ? { authSource: AuthSource.SpxStaff }
    : { auth_source: AuthSource.SpxStaff };

  if (options?.thirdPartyChannel === undefined) {
    return base;
  }

  return {
    ...base,
    tob_login_third_party_type: String(options.thirdPartyChannel),
  };
}
